// extracted by mini-css-extract-plugin
module.exports = {"full":"style_full__ebizl","phone":"style_phone__6wi_k","max":"style_max__XRngv","min":"style_min__0jHjg","mobile":"style_mobile__qgf4E","mobilePhone":"style_mobile-phone__a5O5X"};